import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * A section that displays the customer's recently viewed products, sourced
 * from local storage and rendered using the predictive search section.
 *
 * @typedef {object} Refs
 * @property {HTMLUListElement} grid
 *
 * @extends {Component<Refs>}
 */
class RecentlyViewedProductsSection extends Component {
  requiredRefs = ['grid'];

  connectedCallback() {
    super.connectedCallback();
    this.#renderProducts();
  }

  async #renderProducts() {
    const excludeId = this.dataset.excludeProductId;
    const maxProducts = Number(this.dataset.maxProducts) || 4;

    let productIds = RecentlyViewed.getProducts();

    if (excludeId) {
      productIds = productIds.filter((id) => id !== excludeId);
    }

    if (productIds.length === 0) return;

    productIds = productIds.slice(0, maxProducts);

    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    /** @type {string | null} */
    let markup = null;

    try {
      markup = await sectionRenderer.getSectionHTML('predictive-search', false, url);
    } catch (error) {
      return;
    }

    if (!markup) return;

    const parsedDocument = new DOMParser().parseFromString(markup, 'text/html');
    const cards = parsedDocument.querySelectorAll('#predictive-search-products .resource-card');

    if (cards.length === 0) return;

    const { grid } = this.refs;
    const fragment = document.createDocumentFragment();

    for (const card of cards) {
      const item = document.createElement('li');
      item.className = 'resource-list__item';
      item.append(card);
      fragment.append(item);
    }

    grid.append(fragment);
    this.removeAttribute('hidden');
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProductsSection);
}
